itsoftApp.createModule("buyingHover", function () {
    const module = this;

    const BuyingHover = function () {
        this.container = document.querySelector('.js-byuing-hover');
        this.links = this.container && this.container.querySelectorAll('a');

        this.classNames = {
            hover: '_hover',
        };

        if (this.container) {
            this.init();
        }
    };

    BuyingHover.prototype.init = function () {
        this.addListeners();
    };


    BuyingHover.prototype.addListeners = function () {
        this.addListenerMouseEnter();
        this.addListenerMouseLeave();
    };

    BuyingHover.prototype.addListenerMouseEnter = function () {
        for (let index = 0; index < this.links.length; index++) {
            const el = this.links[index];
            el.addEventListener('mouseenter', this.onMouseEnter.bind(this));
        }
    };

    BuyingHover.prototype.addListenerMouseLeave = function () {
        for (let index = 0; index < this.links.length; index++) {
            const el = this.links[index];
            el.addEventListener('mouseleave', this.onMouseLeave.bind(this));
        }
    };

    BuyingHover.prototype.onMouseEnter = function (e) {
        e.target.classList.add(this.classNames.hover);
        this.container.classList.add(this.classNames.hover);
    };

    BuyingHover.prototype.onMouseLeave = function (e) {
        e.target.classList.remove(this.classNames.hover);
        this.container.classList.remove(this.classNames.hover);
    };

    new BuyingHover();
    module.callback = BuyingHover;
});
